/* eslint-disable */
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import history from 'routes/history';
import actionLoader from 'store/modules/loader/actions';
import { GET_ADMIN_LOGIN } from 'services/Admin';
import { LOGIN, LOGOUT, LOGIN_WITH_TOKEN } from 'services/Login';

const useAuth = () => {
  const dispatch = useDispatch();

  const [loaderShowing, setShowLoader] = useState(false);
  const [userData, setUserData] = useState({
    atualizarDados: false,
    jwtToken: null,
    userId: null,
    authenticated: false,
    nome: null,
    regionalId: null,
    siglaTipo: null,
  });

  useEffect(() => {
    async function autoLogin() {
      const loginUserData = JSON.parse(localStorage.getItem('encartes_baruel_site'));
      setUserData(loginUserData);
    }
    autoLogin();
  }, []);

  async function handleLogin({ username, password, redirect }) {
    showLoader(true);

    const {
      value: { authenticated, nome, userId, regionalId, atualizarDados, siglaTipo },
      jwtToken,
    } = await LOGIN({ username, password });

    localStorage.setItem(
      'encartes_baruel_site',
      JSON.stringify({
        jwtToken,
        userId,
        authenticated,
        nome,
        regionalId,
        atualizarDados,
        siglaTipo
      })
    );
    localStorage.setItem('token', jwtToken);
    setUserData({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      siglaTipo
    });
    showLoader(false);
    if (authenticated === true) {
      history.push(redirect);
    }
    return authenticated;
  }

  async function handleLogout() {
    showLoader(true);
    await LOGOUT();
    localStorage.removeItem('encartes_baruel_site');
    setUserData({
      atualizarDados: false,
      jwtToken: null,
      userId: null,
      authenticated: false,
      nome: null,
      regionalId: null,
      siglaTipo: null,
    });
    history.replace('/login');
    showLoader(false);
  }

  async function adminLoginAs(usuarioId, redirect) {
    showLoader(true);

    let response = await GET_ADMIN_LOGIN(usuarioId);

    const {
        value: { authenticated, nome, userId, regionalId, atualizarDados, siglaTipo },
        jwtToken,
      } = response;

    setLocalStorage({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      siglaTipo
    });

    showLoader(false);
    history.push(redirect || '/');
  }

  async function loginWithToken(token) {
    showLoader(true);
    const {
      value: {
        authenticated,
        nome,
        userId,
        regionalId,
        atualizarDados,
        urlRedirect,
        error,
        siglaTipo
      },
      jwtToken,
    } = await LOGIN_WITH_TOKEN({ token: token });

    if (error?.length) {
      history.push('/');
      return;
    }

    setLocalStorage({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      siglaTipo
    });

    history.push(urlRedirect || '/');
    showLoader(false);
  }

  function setLocalStorage(user) {
    localStorage.setItem('encartes_baruel_site', JSON.stringify(user));
    localStorage.setItem('token', user.jwtToken);
    setUserData(user);
  }

  async function showLoader(value) {
    dispatch(actionLoader.showLoader(value));
    setShowLoader(value);
  }

  return {
    loaderShowing,
    showLoader,
    handleLogin,
    handleLogout,
    userData,
    setUserData,
    adminLoginAs,
    loginWithToken,
  };
};

export default useAuth;
